import { useState } from 'react';
import _ from 'lodash';
import {
  StyledExpandToggler,
  StyledTeamRow,
  StyledTeamRowContainer
} from './TeamsPicker.style';
import Checkbox from 'components/base/Checkbox';
import { boolPropsToClassNames } from 'common/utils/style.utils';

const TeamRow = ({
  team,
  selectedTeam,
  onClickTeam,
  toggleTeamCheckbox,
  isTeamChecked = _.noop,
  isTeamChildChecked = _.noop,
  isDisabled,
  treeLevel = 0
}) => {
  const isChildChecked = isTeamChildChecked(team);

  const [isExpanded, setIsExpanded] = useState(false);
  const toggleIsExpanded = () => setIsExpanded(value => !value);

  const teamChildren = team?.children || [];
  const isParent = team?.isParent;
  const totalMembers = team?.totalMembers || 'N/A';

  const isSelected = selectedTeam?.id === team?.id;
  const isChecked = isTeamChecked(team);

  return (
    <StyledTeamRowContainer treeLevel={treeLevel}>
      <StyledTeamRow
        className={`row team level-${treeLevel} ${boolPropsToClassNames({
          isSelected
        })}`}
      >
        <Checkbox
          disabled={isDisabled}
          checked={isChecked}
          indeterminate={isChildChecked && !isChecked}
          onClick={() => toggleTeamCheckbox(team)}
        />
        {isParent && (
          <StyledExpandToggler
            onClick={toggleIsExpanded}
            data-cy='children-toggler'
          >
            {isExpanded ? '-' : '+'}
          </StyledExpandToggler>
        )}
        <div className='team-name' onClick={() => onClickTeam(team)}>
          {team.name} ({totalMembers})
        </div>
      </StyledTeamRow>
      {isExpanded && (
        <main className='expanded-teams'>
          {teamChildren.map(team => (
            <TeamRow
              key={team.id}
              team={team}
              selectedTeam={selectedTeam}
              onClickTeam={onClickTeam}
              toggleTeamCheckbox={toggleTeamCheckbox}
              treeLevel={treeLevel + 1}
              isTeamChecked={isChecked ? team => true : isTeamChecked}
              isTeamChildChecked={isTeamChildChecked}
              isDisabled={isChecked}
            />
          ))}
        </main>
      )}
    </StyledTeamRowContainer>
  );
};

export default TeamRow;
